var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.$style['pt-img'],attrs:{"src":_vm.isIncludeHttp?_vm.src:_vm.styleName?(_vm.imgUrl+_vm.src+ '?x-image-process=style/'+_vm.styleName):_vm.imgUrl+_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }